import { UserPermissionTypes } from "@enums/user-permission-types";


export const SKIP_REVIEW_EMAILS_PREFERENCE_NAME = "skipReviewEmails";

export const USER_PREFERENCES_PERMISSIONS = [
    UserPermissionTypes.SUBMIT_WORKFLOWS,
    UserPermissionTypes.REVIEW_WORKFLOWS,
    UserPermissionTypes.SUBMIT_SERVICES,
    UserPermissionTypes.REVIEW_SERVICES,
    UserPermissionTypes.SUBMIT_IDPS,
    UserPermissionTypes.REVIEW_IDPS,
];